/* ===========================================================================
   BYG Moto — byg-video-lazy.js  (Paket C, Punkt 2)

   Problem (gemessen am Preview-Theme 181771698443, iPhone-Viewport 375x812):
     Das Hero-Video sitzt 1.629 px unter der Falz, laeuft aber mit autoplay.
     Nach 9 Sekunden ganz ohne Scrollen waren 23,21 s Video gepuffert. Die
     Datei ist 34.691.709 Byte gross (1080p, 7,2 Mbit/s, 38,4 s Laufzeit).

   Was passiert:
     1. Das Laden wird schon im <head> abgefangen (Inline-Schnipsel in
        layout/theme.liquid: Ereignis "loadstart" in der Capture-Phase, also
        BEVOR das erste Byte Video fliesst) und die Quellen werden geparkt.
     2. Hier bekommt jedes geparkte Video einen IntersectionObserver. Erst
        wenn es in Sichtweite kommt (200 px Vorlauf), werden die Quellen
        zurueckgehaengt und abgespielt.
     3. Verlaesst das Video den Bildschirm, wird pausiert.
     4. Auf schmalen Viewports wird die kleinere Fassung genommen, die Shopify
        zu jedem Video ohnehin ablegt. Gemessen an genau diesem Video:
            SD-480p  1.5 Mbps   7.241.829 B
            HD-720p  4.5 Mbps  21.684.031 B
            HD-1080p 7.2 Mbps  34.691.709 B
        Die Originalfassung bleibt als zweite <source> stehen — faellt die
        kleinere URL aus, wechselt der Browser von selbst zurueck.

   Warum die Nutzer-Pause ueber den KNOPF erkannt wird und nicht ueber das
   pause-Ereignis: im Pruefstand hat Chrome ein frisch gestartetes Video nach
   20 ms von sich aus wieder pausiert (Hintergrund-Tab / Energiesparen). Ein
   pause-Ereignis bedeutet also NICHT, dass der Besucher auf Pause gedrueckt
   hat. Wer wirklich drueckt, klickt [data-byg-video-toggle] — darauf hoeren
   wir, und dann draengt sich das Video auch nicht wieder auf.

   Ohne JavaScript passiert nichts von alledem — das Video verhaelt sich dann
   exakt wie heute (Poster + autoplay), die Seite bleibt vollstaendig.
   =========================================================================== */
(function () {
  'use strict';

  var P = window.__bygLazyVideo;
  if (!P) return;
  P.ready = true;
  if (P.t) { clearTimeout(P.t); P.t = null; }

  var reduced = false;
  try {
    reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var watched = [];

  /* --- passende Shopify-Fassung bestimmen ------------------------------- */
  function rendition(url) {
    if (!url) return null;
    var w = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    var dpr = window.devicePixelRatio || 1;
    if (dpr > 2) dpr = 2;
    var need = w * dpr;
    var want = null;
    if (need <= 900) want = 'SD-480p-1.5Mbps';
    else if (need <= 1500) want = 'HD-720p-4.5Mbps';
    if (!want) return null;
    var re = /\.HD-1080p-[0-9.]+Mbps-(\d+)\.mp4/;
    var m = re.exec(url);
    if (!m) return null;
    return url.replace(re, '.' + want + '-' + m[1] + '.mp4');
  }

  /* --- Quellen zurueckhaengen ------------------------------------------- */
  function restore(v, then) {
    if (v.__bygRestored) { if (then) then(); return; }
    v.__bygRestored = true;

    var list = v.__bygSrc || [];
    var kids = v.getElementsByTagName('source');
    var i;
    for (i = 0; i < kids.length && i < list.length; i++) {
      if (list[i].src) kids[i].setAttribute('src', list[i].src);
    }
    if (!kids.length && list.length && list[0].src) {
      v.setAttribute('src', list[0].src);
    }
    if (kids.length && list.length) {
      var alt = rendition(list[0].src);
      if (alt) {
        var s = document.createElement('source');
        s.setAttribute('src', alt);
        s.setAttribute('type', list[0].type || 'video/mp4');
        v.insertBefore(s, kids[0]);
      }
    }

    /* Erst abspielen, wenn Metadaten da sind — ein play() mitten im
       load()-Vorgang wird vom Browser sofort wieder zurueckgenommen. */
    var fired = 0;
    function done() {
      if (fired) return;
      fired = 1;
      v.removeEventListener('loadedmetadata', done);
      v.removeEventListener('error', done);
      if (then) then();
    }
    v.addEventListener('loadedmetadata', done);
    v.addEventListener('error', done);
    v.setAttribute('preload', reduced ? 'metadata' : 'auto');
    try { v.load(); } catch (e) {}
    setTimeout(done, 4000); /* Notbremse, falls kein Ereignis kommt */
  }

  function userPaused(v) {
    return v.getAttribute('data-byg-user-paused') === '1';
  }

  function tryPlay(v) {
    if (reduced || userPaused(v) || !v.paused) return;
    var p;
    try { p = v.play(); } catch (e) { return; }
    if (p && typeof p.catch === 'function') p.catch(function () { nachGeste(v); });
  }

  /* 08.10.2026 — Manuel: "Das Video soll automatisch abgespielt werden."
     iOS verweigert play() z. B. im Stromsparmodus und zeigt dann seinen
     eigenen Play-Knopf ueber dem Video. Der wird per CSS versteckt
     (byg-hero.css); hier startet das Video stattdessen bei der ersten
     Beruehrung irgendwo auf der Seite — iOS erlaubt play() innerhalb
     einer Nutzergeste. Einmalig, danach raeumen sich die Listener weg. */
  var gesteWartet = false;
  function nachGeste(v) {
    if (gesteWartet) return;
    gesteWartet = true;
    function los() {
      document.removeEventListener('touchend', los, true);
      document.removeEventListener('click', los, true);
      gesteWartet = false;
      for (var i = 0; i < watched.length; i++) {
        if (watched[i].__bygInView || watched[i] === v) tryPlay(watched[i]);
      }
    }
    document.addEventListener('touchend', los, true);
    document.addEventListener('click', los, true);
  }

  function activate(v) {
    v.__bygInView = 1;
    if (v.__bygRestored) { tryPlay(v); return; }
    restore(v, function () { if (v.__bygInView) tryPlay(v); });
  }

  function deactivate(v) {
    v.__bygInView = 0;
    if (!v.__bygRestored || v.paused) return;
    try { v.pause(); } catch (e) {}
  }

  /* --- Nutzer-Pause: am Knopf erkannt, nicht am pause-Ereignis ----------- */
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      var btn = t && t.closest ? t.closest('[data-byg-video-toggle]') : null;
      if (!btn) return;
      var wrap = btn.closest('[data-byg-hero-video]') || btn.parentNode;
      var v = wrap && wrap.querySelector ? wrap.querySelector('video') : null;
      if (!v) return;
      setTimeout(function () {
        if (v.paused) v.setAttribute('data-byg-user-paused', '1');
        else v.removeAttribute('data-byg-user-paused');
      }, 0);
    },
    true
  );

  /* Kommt der Tab aus dem Hintergrund zurueck, darf weitergelaufen werden —
     der Browser pausiert dort von sich aus, das ist keine Nutzer-Pause. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    for (var i = 0; i < watched.length; i++) {
      if (watched[i].__bygInView) tryPlay(watched[i]);
    }
  });

  function setup() {
    watched = (P.q || []).slice();
    if (!watched.length) return;
    var i;
    if (typeof window.IntersectionObserver !== 'function') {
      for (i = 0; i < watched.length; i++) activate(watched[i]);
      return;
    }
    var io = new window.IntersectionObserver(
      function (entries) {
        for (var k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) activate(entries[k].target);
          else deactivate(entries[k].target);
        }
      },
      { rootMargin: '200px 0px 200px 0px', threshold: 0.01 }
    );
    for (i = 0; i < watched.length; i++) io.observe(watched[i]);
    P.io = io;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
